export default __webpack_public_path__ + "static/media/avion.cc6b4b7b.svg";